// Booking-control route registry — AI typed navigation tools sinh từ đây.
//
// Mỗi entry → 1 tool AI có thể gọi. Tool execute = navigate đến path (replace :params).
// Description phải rõ ràng cho AI biết khi nào dùng.
//
// Quy tắc khi thêm route mới:
//   - name: verb prefix (view_*, open_*)
//   - path: match exactly route trong app.tsx
//   - description: giải thích khi nào dùng + nhắc dùng REAL ID nếu cần

import type { RouteEntry } from "./solid-agent-ui";

export const BOOKING_ROUTES: RouteEntry[] = [
  // ─── Public / user routes ─────────────────────────────────
  {
    name: "view_item_detail",
    path: "/items/:id",
    description:
      "Navigate to PUBLIC item detail page (user view) where user can book. Use REAL item ID (UUID). If user mentions item by NAME only, call find_item_by_name FIRST to resolve.",
    params: {
      id: { type: "string", required: true, description: "Real item UUID (not name)" },
    },
  },
  {
    name: "view_items_list",
    path: "/items",
    description: "Navigate to public items grid (browse all bookable items).",
  },
  {
    name: "view_my_tickets",
    path: "/me/tickets",
    description: "Navigate to current user's tickets page (show user's reservations).",
  },

  // ─── Admin routes ─────────────────────────────────────────
  {
    name: "view_admin_items_list",
    path: "/admin/items",
    description: "Navigate to admin booking items table (CRUD list).",
  },
  {
    name: "view_admin_item_rules",
    path: "/admin/items/:id",
    description: "Navigate to admin item detail (per-item rule override). REAL item ID required.",
    params: {
      id: { type: "string", required: true, description: "Real item UUID" },
    },
  },
  {
    name: "view_admin_groups_list",
    path: "/admin/groups",
    description: "Navigate to admin groups table.",
  },
  {
    name: "view_admin_group_detail",
    path: "/admin/groups/:id",
    description:
      "Navigate to admin group detail (metadata + rule override + 2-step flow config). REAL group ID required.",
    params: {
      id: { type: "string", required: true, description: "Real group UUID" },
    },
  },
  {
    name: "view_admin_tickets",
    path: "/admin/tickets",
    description: "Navigate to admin tickets page (search by item/user, void).",
  },
  {
    name: "view_admin_rules",
    path: "/admin/rules",
    description: "Navigate to admin rules config (global rule engine settings).",
  },
  {
    name: "view_admin_clients",
    path: "/admin/clients",
    description: "Navigate to admin clients/users list.",
  },
  {
    name: "view_admin_ai_config",
    path: "/admin/ai",
    description: "Navigate to admin AI assistant config page.",
  },
];
